import React, { Fragment, useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Grid,
  Button,
  Card,
  OutlinedInput,
  InputAdornment,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

import SpinnerSmall from "../../../layout/SpinnerSmall";

import ConfirmationModal from "./ConfirmationModal";

const FunctionMakeOffer = ({
  state,
  setState,
  dispute,
  selectedFunction,
  handleClose,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { makeOffer, loading } = disputeContext;

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmDisplay, setConfirmDisplay] = useState("");

  const [refundType, setRefundType] = useState([]);
  const [showRefundAmount, setShowRefundAmount] = useState(false);

  useEffect(() => {
    if (dispute) {
      if (dispute.reason === "MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED") {
        setRefundType([
          {
            type: "REFUND",
            label: "Refund",
          },
          {
            type: "REFUND_WITH_RETURN",
            label: "Refund with Return",
          },
          {
            type: "REFUND_WITH_REPLACEMENT",
            label: "Refund with Replacement",
          },
          {
            type: "REPLACEMENT_WITHOUT_REFUND",
            label: "Replacement without Refund",
          },
        ]);
      } else if (dispute.reason === "MERCHANDISE_OR_SERVICE_NOT_RECEIVED") {
        setRefundType([
          {
            type: "REFUND",
            label: "Refund",
          },
        ]);
      }
    }
  }, [dispute]);

  useEffect(() => {
    if (
      state.make_offer.refundType_value === "REFUND" ||
      state.make_offer.refundType_value === "REFUND_WITH_RETURN" ||
      state.make_offer.refundType_value === "REFUND_WITH_REPLACEMENT"
    ) {
      setShowRefundAmount(true);
    } else {
      setShowRefundAmount(false);
    }
  }, [state.make_offer.refundType_value]);

  const useStyles = makeStyles((theme) => ({
    modalBody: {
      padding: theme.spacing(2),
    },
    inputWidth: {
      width: "100%",
    },
    helper: {
      color: "#ff3333",
    },
  }));

  const classes = useStyles();

  //Filter Input Value
  const onInputChange = (e) => {
    e.preventDefault();
    e.persist();
    const amountRegex = /^[0-9]+(\.[0-9][0-9]?)?$/g;

    if (e.target.id === "note_value") {
      const value = e.target.value;
      let errors = state.make_offer.errors;
      let make_offer = state.make_offer;
      if (value.length > 2000) {
        errors.note_value = "Maximum 2000 characters";
      } else {
        errors.note_value = "";
      }
      make_offer.note_value = value;
      setState((state) => ({
        ...state,
        make_offer: make_offer,
      }));
    }
    if (e.target.id === "amount_value") {
      const value = e.target.value.trim();
      let errors = state.make_offer.errors;
      let make_offer = state.make_offer;
      if (parseFloat(value) > parseFloat(dispute.dispute_amount.value)) {
        errors.amount_value = "Refund amount is greater than dispute amount.";
      } else if (value === "" || amountRegex.test(value)) {
        errors.amount_value = "";
      } else {
        errors.amount_value = "Invalid Amount Input";
      }
      make_offer.amount_value = value;
      setState((state) => ({
        ...state,
        make_offer: make_offer,
      }));
    }
  };

  const onRefundTypeSelect = (e) => {
    e.preventDefault();
    let make_offer = state.make_offer;
    make_offer.refundType_value = e.target.value;
    setState((state) => ({
      ...state,
      make_offer: make_offer,
    }));
  };

  const [isLoading, setIsLoading] = useState();
  const [okClick, setOkCLick] = useState();

  useEffect(() => {
    if (isLoading === true) {
      if (loading === false) {
        handleClose();
        setIsLoading(false);
      }
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    if (okClick === "make_offer") {
      if (state.make_offer.refundType_value === "REPLACEMENT_WITHOUT_REFUND") {
        makeOffer(
          dispute.dispute_id,
          state.make_offer.note_value,
          state.make_offer.refundType_value,
          ""
        );
        setReturnedMsg("");
        setIsLoading(true);
      } else {
        makeOffer(
          dispute.dispute_id,
          state.make_offer.note_value,
          state.make_offer.refundType_value,
          state.make_offer.amount_value
        );
        setReturnedMsg("");
        setIsLoading(true);
      }
      setOkCLick("");
    }
    //eslint-disable-next-line
  }, [okClick]);

  const onSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true);
    var displayRefundType = "";
    for (let x in refundType) {
      if (refundType[x].type === state.make_offer.refundType_value) {
        displayRefundType = refundType[x].label;
      }
    }

    if (state.make_offer.refundType_value === "REPLACEMENT_WITHOUT_REFUND") {
      setConfirmDisplay([
        {
          label: "Refund Type",
          value: displayRefundType,
        },
        {
          label: "Note",
          value: state.make_offer.note_value,
        },
      ]);
    } else {
      setConfirmDisplay([
        {
          label: "Refund Type",
          value: displayRefundType,
        },
        {
          label: "Refund Amount",
          value: state.make_offer.amount_value + " USD",
        },
        {
          label: "Note",
          value: state.make_offer.note_value,
        },
      ]);
    }
  };

  return (
    <Fragment>
      {" "}
      {selectedFunction === "make_offer" ? (
        <Grid container direction="column" className={classes.modalBody}>
          <Card className={classes.modalBody}>
            <Grid container direction="column" spacing={4}>
              <Grid item>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={8}>
                    <TextField
                      label="Refund Type"
                      variant="outlined"
                      type="text"
                      select
                      id="offertype_value"
                      name="offertype_value"
                      fullWidth
                      value={state.make_offer.refundType_value}
                      onChange={onRefundTypeSelect}
                      disabled={loading === false ? false : true}
                    >
                      {refundType.map((each) => (
                        <MenuItem key={each.type} value={each.type}>
                          {" "}
                          {each.label}{" "}
                        </MenuItem>
                      ))}{" "}
                    </TextField>{" "}
                  </Grid>{" "}
                  {showRefundAmount ? (
                    <Grid item xs={4}>
                      <OutlinedInput
                        type="text"
                        id="amount_value"
                        name="amount_value"
                        placeholder="Refund Amount"
                        className={classes.inputWidth}
                        endAdornment={
                          <InputAdornment position="end"> USD </InputAdornment>
                        }
                        value={state.make_offer.amount_value}
                        onInput={onInputChange}
                        error={
                          state.make_offer.errors.amount_value ? true : false
                        }
                        disabled={loading === false ? false : true}
                      />{" "}
                    </Grid>
                  ) : null}{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="note_value"
                  name="note_value"
                  size="small"
                  fullWidth
                  label="Note"
                  placeholder="Leave a note..."
                  multiline
                  rows={10}
                  maxRows={20}
                  value={state.make_offer.note_value}
                  onInput={onInputChange}
                  helperText={
                    state.make_offer.errors.note_value
                      ? state.make_offer.errors.note_value
                      : ""
                  }
                  error={state.make_offer.errors.note_value ? true : false}
                  disabled={loading === false ? false : true}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item>
                    <FormHelperText className={classes.helper}>
                      {" "}
                      {state.make_offer.errors.amount_value}{" "}
                    </FormHelperText>{" "}
                  </Grid>{" "}
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={onSubmit}
                      disabled={
                        state.make_offer.note_value.length > 0 &&
                        state.make_offer.note_value.length <= 2000 &&
                        state.make_offer.refundType_value &&
                        loading === false &&
                        (state.make_offer.refundType_value !==
                        "REPLACEMENT_WITHOUT_REFUND"
                          ? state.make_offer.errors.amount_value === "" &&
                            state.make_offer.amount_value
                          : true)
                          ? false
                          : true
                      }
                    >
                      {loading ? (
                        <div className="d-flex mx-auto my-auto">
                          <SpinnerSmall />
                        </div>
                      ) : (
                        <Fragment> {"Submit"} </Fragment>
                      )}{" "}
                    </Button>{" "}
                  </Grid>{" "}
                </Grid>{" "}
                <ConfirmationModal
                  confirmModal={confirmModal}
                  setConfirmModal={setConfirmModal}
                  confirmDisplay={confirmDisplay}
                  setConfirmDisplay={setConfirmDisplay}
                  setOkCLick={setOkCLick}
                  selectedFunction={selectedFunction}
                />{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Card>{" "}
        </Grid>
      ) : null}{" "}
    </Fragment>
  );
};

export default FunctionMakeOffer;
